import React, { use } from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import Button from '@components/atoms/button/button';
import { Product } from '@interfaces/models/orderSaleProduct';
import { ROUTER_QUERY_KEY } from '@hooks/orders-sales/use-query-tab';
import { TimelineContext } from '@context/timeline.context';
import { getOrderSaleURLQueries, updateURLQueries } from '@components/orders-sales/helper';
import { useRouter } from 'next/router';
import styles from '../../main.module.scss';

interface GetShippingLabelButtonProps {
  product: Product;
  shippingLabelUrl?: string;
}

const GetShippingLabelButton = ({ product, shippingLabelUrl }: GetShippingLabelButtonProps) => {
  const { sendAnalyticEvent } = useAnalyticEvents('orders_sales_timeline');

  const { t } = useTranslation('orders-sales');

  const router = useRouter();

  const { state, updateState } = use(TimelineContext);

  const { section } = getOrderSaleURLQueries();

  if (!shippingLabelUrl || !product) {
    return null;
  }

  const tracking = () => sendAnalyticEvent('my_account_download_label', { product_id: product.productId });

  return (
    <>
      {section === ROUTER_QUERY_KEY.order ? (
        <a
          className={clsx('vc-btn vc-btn--medium vc-btn--primary', styles.ordersSales__shipping__btn__download)}
          href={`/my-account/orders-sales/?section=${ROUTER_QUERY_KEY.sale}&waitingToShipProduct=${product.productId}`}
          onClick={tracking}
        >
          {t('MY_ACCOUNT.ORDERS_SALES.SHIPPING.GET_SHIPPING_LABEL')}
        </a>
      ) : (
        <Button
          variant="primary"
          size="medium"
          onClick={() => {
            tracking();
            updateURLQueries(router.pathname, { waitingToShipProduct: product.productId });
            updateState({
              ...state,
              saleProduct: product,
            });
          }}
        >
          {t('MY_ACCOUNT.ORDERS_SALES.SHIPPING.GET_SHIPPING_LABEL')}
        </Button>
      )}
    </>
  );
};

export default GetShippingLabelButton;
